import { render, staticRenderFns } from "./FoodPush.vue?vue&type=template&id=1b9ded7b&scoped=true&"
import script from "./FoodPush.vue?vue&type=script&lang=js&"
export * from "./FoodPush.vue?vue&type=script&lang=js&"
import style0 from "./FoodPush.vue?vue&type=style&index=0&id=1b9ded7b&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9ded7b",
  null
  
)

export default component.exports